import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import useSetState from '../../../hooks/useSetState';
import { addNewCity, updateCity } from '../../../redux/cities/actions';
import { formatter } from '../../../utils';

const AddOrEditCity = props => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [controls, setControls] = useSetState({
    name: '',
    cityCode: '',
    id: '',
    hasRegistrationFee: false,
    initialContractTerm: '',
    registrationFee: '',
    subscriptionFee_6_months: '',
    subscriptionFee_12_months: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const OnSubmitAddCityForm = event => {
    event.preventDefault();

    const standardRegistrationFee = formatter.toStandard(
      String(controls.registrationFee).replaceAll(',', ''),
    );

    const standardSubscriptionFee_6_months = formatter.toStandard(
      String(controls.subscriptionFee_6_months).replaceAll(',', ''),
    );
    const standardSubscriptionFee_12_months = formatter.toStandard(
      String(controls.subscriptionFee_12_months).replaceAll(',', ''),
    );

    let data = {
      name: controls.name,
      cityCode: controls.cityCode,
      hasRegistrationFee: controls.hasRegistrationFee,
      initialContractTerm: controls.initialContractTerm,
      subscriptionFee_6_months: standardSubscriptionFee_6_months,
      subscriptionFee_12_months: standardSubscriptionFee_12_months,
    };

    controls.hasRegistrationFee &&
      (data = { ...data, registrationFee: standardRegistrationFee });

    if (props.location.editMode) {
      dispatch(updateCity(data, controls.id))
        .then(() => history.push('/cities-and-regions'))
        .catch(error => console.log('error', error));
    } else {
      dispatch(addNewCity(data))
        .then(() => history.push('/cities-and-regions'))
        .catch(error => console.log('error', error));
    }
  };

  useEffect(() => {
    if (props.location.editMode) {
      onChangeValue('id', props.location.item.id);
      onChangeValue('name', props.location.item.name);
      onChangeValue('cityCode', props.location.item.cityCode);
      props.location.item.registrationFee > 0
        ? onChangeValue('hasRegistrationFee', true)
        : onChangeValue('hasRegistrationFee', false);
      onChangeValue(
        'initialContractTerm',
        props.location.item.initialContractTerm,
      );
      onChangeValue('registrationFee', props.location.item.registrationFee);
      onChangeValue(
        'subscriptionFee_6_months',
        props.location.item.subscriptionFee_6_months,
      );
      onChangeValue(
        'subscriptionFee_12_months',
        props.location.item.subscriptionFee_12_months,
      );
    }
  }, [props]);

  return (
    <section>
      <section className='page-header'>
        <h1 className='panel-title'>
          <i className='fa fa-pencil' />
          {props.location.editMode
            ? locales('edit.city')
            : locales('add.new.city')}
        </h1>
        <div className='form-actions'>
          <button
            form='addOrEditCity'
            type='submit'
            className='btn btn-success w-100'
          >
            <i className='fa fa-save' />
            {locales('labels.save')}
          </button>
          <Link to='/cities-and-regions' className='btn btn-default'>
            <i className='fa fa-reply' />
            {locales('label.cancel')}
          </Link>
        </div>
      </section>

      <section className='panel panel-default'>
        <div className='panel-body'>
          <form
            className='col form-horizontal'
            onSubmit={OnSubmitAddCityForm}
            id='addOrEditCity'
          >
            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-4 text-right'>
                  {locales('tables.cityName')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      id='name'
                      name='name'
                      type='text'
                      placeholder={locales('example.shiraz')}
                      className='form-control full-width'
                      value={controls.name}
                      onChange={e => onChangeValue('name', e.target.value)}
                      disabled={props.location.editMode && true}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-4 text-right'>
                  {locales('city.code')}
                </label>
                <div className='full-width'>
                  <div className='input-group'>
                    <input
                      id='cityCode'
                      name='cityCode'
                      type='text'
                      placeholder='SHZ'
                      className={`form-control full-width'}`}
                      onChange={e => onChangeValue('cityCode', e.target.value)}
                      autoComplete='off'
                      value={controls.cityCode}
                      disabled={props.location.editMode && true}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-4 text-right'>
                  {locales('contract.duration.month')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      id='initialContractTerm'
                      name='initialContractTerm'
                      type='text'
                      className='form-control full-width'
                      value={controls.initialContractTerm}
                      onChange={e =>
                        onChangeValue('initialContractTerm', e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='col-lg-8 col-md-12 col-sm-12 d-flex'>
                <div className='form-group col-4 d-flex'>
                  <label className='rsee-form-label col-lg-10 col-md-4 text-right'>
                    {locales('messages.hasRegistrationFee')}
                  </label>
                  <div className='full-width'>
                    <div className='input-group'>
                      <input
                        id='hasRegistrationFee'
                        name='hasRegistrationFee'
                        type='checkbox'
                        onChange={e => {
                          onChangeValue(
                            'hasRegistrationFee',
                            !controls.hasRegistrationFee,
                          );
                          !e.target.checked &&
                            onChangeValue('registrationFee', '');
                        }}
                        value={controls.hasRegistrationFee}
                        checked={controls.hasRegistrationFee}
                      />
                    </div>
                  </div>
                </div>

                <div className='form-group full-width d-flex'>
                  <label className='rsee-form-label col-4 text-right'>
                    {locales('registration.fee.toman')}
                  </label>
                  <div className='full-width'>
                    <div className='full-width d-flex justify-content-start'>
                      <input
                        id='registrationFee'
                        name='registrationFee'
                        type='text'
                        className='form-control full-width'
                        value={controls.registrationFee.toLocaleString()}
                        onChange={e => {
                          let value = new Intl.NumberFormat().format(
                            e.target.value.replaceAll(',', ''),
                          );
                          onChangeValue('registrationFee', value);
                        }}
                        disabled={!controls.hasRegistrationFee}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-4 text-right'>
                  {locales('six.month.subscription.fee.toman')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      id='subscriptionFee_6_months'
                      name='subscriptionFee_6_months'
                      type='text'
                      className='form-control full-width'
                      value={controls.subscriptionFee_6_months.toLocaleString()}
                      onChange={e => {
                        let value = new Intl.NumberFormat().format(
                          e.target.value.replaceAll(',', ''),
                        );
                        onChangeValue('subscriptionFee_6_months', value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-4 text-right'>
                  {locales('twelve.month.subscription.fee.toman')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      id='subscriptionFee_12_months'
                      name='subscriptionFee_12_months'
                      type='text'
                      className='form-control full-width'
                      value={controls.subscriptionFee_12_months.toLocaleString()}
                      onChange={e => {
                        let value = new Intl.NumberFormat().format(
                          e.target.value.replaceAll(',', ''),
                        );
                        onChangeValue('subscriptionFee_12_months', value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </section>
  );
};

export default AddOrEditCity;
